/* SearchDropdownOverlay.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["mobileVisibility"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "@media (min-width:64rem){._1yagxgen{padding:var(--ds-space-200) var(--ds-space-250) var(--ds-space-150) var(--ds-space-300)}}";
const _10 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _9 = "._zulp1eps{gap:var(--ds-space-100)}";
const _8 = "._4cvr1h6o{align-items:center}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._1yt4ot5x{padding:var(--ds-space-200) var(--ds-space-200) var(--ds-space-150) 0}";
const _5 = "._1bsb1osq{width:100%}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { useHistory, useLocationHref, useQueryParams } from '@atlassian/mpac-ui';
import React, { useCallback, useEffect, useRef } from 'react';
import { useAlgoliaAutocomplete } from '../../AlgoliaClientSDK/useAlgoliaAutocomplete';
import { getSuggestionSource } from '../../analyticsUtils';
import { BODY_STATES, desktopPlaceholder, mobilePlaceholder } from '../../constants';
import { RecentSearch } from '../../SearchUtils';
import { redirectToNewQuery } from '../../SearchUtils/search-navigation-utils/SearchNavigationUtils';
import { SearchBodyFactory } from '../SearchBodyFactory';
import { SearchFooter } from '../SearchFooter';
import { SearchHeader } from '../SearchHeader';
import { useAutocompleteState } from './hooks/useAutocompleteState';
import { useSearchDropdown } from './hooks/useSearchDropdown';
const _4 = "._1e0cglyw{display:none}";
const _3 = "._1e0c1ule{display:block}";
const _2 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _ = "._n7zlsj58{border-bottom:var(--_2rzkic)}";
const Separator = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      mobileVisibility
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_2rzkic": ix("".concat(__cmplp.height, "px solid ", "var(--ds-border)"))
    }),
    ref: __cmplr,
    className: ax(["_n7zlsj58 _dm251ule", __cmplp.mobileVisibility ? "_1e0c1ule" : "_1e0cglyw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Separator.displayName = 'Separator';
}
const Header = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5, _6, _7, _8, _9, _10, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _1yt4ot5x _1e0c1txw _4cvr1h6o _zulp1eps _syaz1jij _1yagxgen", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
// RECENT SEARCH HANDLINGS
const recentSearch = new RecentSearch(5, 'mpac-search-recent-searches');

// eslint-disable-next-line max-lines-per-function
export function SearchDropdownOverlay(_ref3) {
  let {
    closeOverlay,
    onViewed,
    onSuggestionSelection,
    onEnterKeyPress,
    backButtonRef
  } = _ref3;
  // LOCATION HANDLINGS
  const {
    query: queryFromUrl
  } = useQueryParams();
  const locationHref = useLocationHref();
  const history = useHistory();

  // AUTOCOMPLETE HANDLINGS
  const inputRef = useRef(null);
  const searchSuggestionCountRef = useRef(0);
  const hasFiredViewedAnalyticsRef = useRef(false);
  const handleNewSearch = useCallback(hit => {
    var _inputRef$current, _hit$__autocomplete_i;
    const inputValue = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value;
    onSuggestionSelection({
      query: hit.query,
      position: ((_hit$__autocomplete_i = hit.__autocomplete_id) !== null && _hit$__autocomplete_i !== void 0 ? _hit$__autocomplete_i : 0) + 1,
      popularity: hit.popularity,
      suggestionSource: getSuggestionSource(!!inputValue),
      count: inputValue ? searchSuggestionCountRef.current : recentSearch.count()
    });
    recentSearch.push(hit);
    redirectToNewQuery({
      query: hit.query,
      locationHref,
      history
    });
    closeOverlay();
  }, [locationHref, history, closeOverlay, onSuggestionSelection]);
  const onFormSubmit = query => {
    handleEnterKeyPress(query);
    closeOverlay();
  };
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.md;
  const {
    autocomplete,
    autocompleteState
  } = useAlgoliaAutocomplete(inputRef, isMobile ? mobilePlaceholder : desktopPlaceholder, queryFromUrl, handleNewSearch, recentSearch);
  const {
    handleAppend,
    handleEnterKeyPress,
    clearRecentSearches,
    clearSearchInput
  } = useSearchDropdown({
    inputRef,
    autocomplete,
    autocompleteState,
    recentSearch,
    onEnterKeyPress
  });

  // BODY STATE HANDLINGS
  const {
    bodyState
  } = useAutocompleteState({
    autocompleteState
  });
  const searchSuggestionProps = {
    hits: autocompleteState.collections,
    autocomplete,
    onAppend: handleAppend
  };
  useEffect(() => {
    var _autocompleteState$co, _autocompleteState$co2, _autocompleteState$co3;
    searchSuggestionCountRef.current = (_autocompleteState$co = (_autocompleteState$co2 = autocompleteState.collections[0]) === null || _autocompleteState$co2 === void 0 ? void 0 : (_autocompleteState$co3 = _autocompleteState$co2.items) === null || _autocompleteState$co3 === void 0 ? void 0 : _autocompleteState$co3.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0;
  }, [bodyState, autocompleteState]);

  // ON MOUNT -- HANDLE ANALYTICS
  useEffect(() => {
    recentSearch.refreshRecentSearches();
    autocomplete.refresh();
    // HANDLE ANALYTICS FOR EMPTY QUERY
    if (!queryFromUrl) {
      onViewed({
        query: '',
        suggestionSource: getSuggestionSource(false),
        count: recentSearch.count()
      });
    }
  }, []);
  useEffect(() => {
    // HANDLE ANALYTICS FOR EXISTING QUERY
    if (queryFromUrl && !hasFiredViewedAnalyticsRef.current) {
      var _inputRef$current$val, _inputRef$current2;
      const inputValue = (_inputRef$current$val = (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.value) !== null && _inputRef$current$val !== void 0 ? _inputRef$current$val : '';
      if ((bodyState === BODY_STATES.SEARCH_RESULTS || bodyState === BODY_STATES.NO_SUGGESTIONS) && autocompleteState.status === 'idle') {
        var _autocompleteState$co4, _autocompleteState$co5, _autocompleteState$co6;
        onViewed({
          query: inputValue,
          suggestionSource: getSuggestionSource(true),
          count: (_autocompleteState$co4 = (_autocompleteState$co5 = autocompleteState.collections[0]) === null || _autocompleteState$co5 === void 0 ? void 0 : (_autocompleteState$co6 = _autocompleteState$co5.items) === null || _autocompleteState$co6 === void 0 ? void 0 : _autocompleteState$co6.length) !== null && _autocompleteState$co4 !== void 0 ? _autocompleteState$co4 : 0
        });
        hasFiredViewedAnalyticsRef.current = true;
      }
    }
  }, [bodyState]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getRootProps({}), /*#__PURE__*/React.createElement(SearchHeader, {
    autocomplete: autocomplete,
    ref: inputRef,
    handleEnterKeyPress: onFormSubmit,
    handleBackClick: closeOverlay,
    clearSearchInput: clearSearchInput,
    isEmbedded: false,
    backButtonRef: backButtonRef
  })), /*#__PURE__*/React.createElement(Separator, {
    height: 2,
    mobileVisibility: true
  }), /*#__PURE__*/React.createElement(SearchBodyFactory, {
    type: bodyState,
    searchQuerySuggestionsBodyProps: _objectSpread({
      query: autocompleteState.query
    }, searchSuggestionProps),
    searchLoadingProps: {
      query: autocompleteState.query
    },
    recentSearchBodyProps: _objectSpread({
      onClearAll: clearRecentSearches
    }, searchSuggestionProps),
    noSuggestionsBodyProps: {
      query: autocompleteState.query
    }
  }), /*#__PURE__*/React.createElement(Separator, {
    height: 1,
    mobileVisibility: false
  }), /*#__PURE__*/React.createElement(SearchFooter, null));
}